import React from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import PropTypes from "prop-types";
import bg from "../../assets/images/HeaderDocument.jpg";
import "./base.css";

const HRM_054 = ({ pdfExportComponent, data, company, company2 }) => {
  return (
    <>
      <div id="document-box" className="documents">
        <PDFExport
          ref={pdfExportComponent}
          fileName={`ข้อห้ามใช้เครื่องหมายการค้าและเปิดเผยข้อมูลผ่าน Social Network - ${data.personal_info_name}`}
          forcePageBreak=".page-break"
        >
          <div id="page1" style={{ fontFamily: "THSarabun" }}>
            <div>
              <img
                id="background"
                src={bg}
                alt="bg"
                style={{
                  width: "800px",
                  height: "auto",
                  position: "absolute",
                  top: "0%",
                  right: "0%",
                  zIndex: -5,
                  boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                }}
              />
            </div>
            <div
              id="content"
              style={{
                zIndex: 2,
              }}
            >
              <div
                id="header"
                class="text-with-bold"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  //26px
                  top: "134px",
                  right: "47px",
                  fontSize: "20.8px",
                  width: "705px",
                  // fontFamily: "angsaBold",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                <b className="docs-font">
                  ข้อห้ามในการใช้เครื่องหมายการค้า(Logo) และเปิดเผยข้อมูล
                  <br />
                  ของบริษัทในทางที่ผิดกฎหมาย
                </b>
              </div>
              <div
                id="formId"
                class="text-with-bold"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "125px",
                  right: "65px",
                  border: "1px",
                  borderStyle: "solid",
                  padding: "8px",
                  paddingBottom: "0px",
                  paddingTop: "5px",
                  width: "70px",
                  fontSize: "16px",
                  letterSpacing: 0.14,
                }}
              >
                <b className="docs-font-bold">HRM-054</b>
              </div>
              <div
                className="docs-font"
                id="date"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "230px",
                  right: "76px",
                  fontSize: "18.2px",
                  // fontFamily: "angsaLight",
                  width: "647px",
                  letterSpacing: 0.14,
                  textAlign: "right",
                }}
              >
                วันที่...........เดือน....................................พ.ศ.................
              </div>
              <div
                id="paragraph1"
                class="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "255px",
                  right: "74px",
                  fontSize: "18.2px",
                  // fontFamily: "angsaLight",
                  width: "655px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  lineHeight: "27px",
                }}
              >
                <p />
                &nbsp;&emsp;&emsp;&emsp;หนังสือฉบับนี้ทำขึ้น ที่บริษัท{" "}
                {company.name_th}
                <br />
                <p />
                &nbsp;&emsp;&emsp;&emsp;ข้าพเจ้านาย/นาง/นางสาว.......……………………………..........................................................................………………….……………….
                อายุ……......………….ปี
                อยู่บ้านเลขที่……….............……….หมู่ที่…..............……ตรอก/ซอย…………….................................………………..…..……
                ถนน
                …………….................................................…………..........…..
                แขวง/ตำบล
                ………….............................................………….........………..
                เขต/อำเภอ …………………………………................…… จังหวัด
                ………………….…….....................….
                ซึ่งต่อไปในหนังสือนี้จะเรียกว่า " ลูกจ้าง "
                ขอทำหนังสือฉบับนี้ให้ไว้กับบริษัท {company.name_th}&nbsp;
                รวมถึงบริษัทในเครือ
                &nbsp;&nbsp;ซึ่งต่อไปในหนังสือนี้จะเรียกรวมกันว่า
                &nbsp;&nbsp;“บริษัท” เพื่อเป็นการรับทราบและตกลงว่า
                <br />
                &nbsp;&emsp;&emsp;&emsp;โดยที่ปัจจุบันมีแหล่งให้บริการเครือข่ายทางสังคมเกิดขึ้นบนระบบเครือข่ายอินเทอร์เน็ตเป็นจำนวนมาก(Social
                Network) ตัวอย่างเช่น Facebook, Twitter, LinkedIn, Google Plus,
                MySpace, YouTube, Blog, Wiki ,Live รวมทั้งเว็บไซต์ต่างๆ
                ทั้งในประเทศและต่างประเทศ ที่เปิดให้บริการ file sharing, photo
                sharing, video sharing และกระดานข่าว (web board) เป็นต้น
                ซึ่งสื่อดังกล่าวเป็นเครื่องมือที่มีทั้งประโยชน์และโทษที่ควรระวัง
                โดยเฉพาะข้อมูลข่าวสารบางอย่างที่เผยแพร่ออกสู่สาธารณะไปแล้วอาจไม่สามารถเรียกกลับคืนได้
                และอาจก่อให้เกิดความเสียหายทั้งต่อตนเอง ต่อผู้อื่น และต่อองค์กร
                ดังนั้น เพื่อให้พนักงานในบริษัททุกท่าน
                สามารถใช้สื่อสังคมออนไลน์ได้อย่างมีประสิทธิภาพและเกิดประโยชน์สูงสุด
                ข้าพเจ้ารับทราบว่าบริษัทฯ
                ได้กำหนดนโยบายและแนวทางปฏิบัติสำหรับผู้ที่ใช้สื่อสังคมออนไลน์
                (Social Network) และแสดงตนในฐานะลูกจ้างของ บริษัทฯ
                เพื่อถือเป็นข้อปฏิบัติตามโดยเคร่งครัด มีรายละเอียดดังนี้
                <br />
                &nbsp;&emsp;&emsp;&emsp;1. ลูกจ้างพึงตระหนักว่า&nbsp;&nbsp;
                ข้อความหรือความเห็นที่เผยแพร่บน&nbsp;&nbsp; Social
                Network&nbsp;&nbsp; เป็นข้อความที่สามารถเข้าถึงได้โดยสาธารณะ
                ผู้เผยแพร่ต้องรับผิดชอบ ทั้งทางด้านสังคม และด้านกฎหมาย นอกจากนี้
                ยังอาจมีผลกระทบต่อชื่อเสียง การทำงานและอนาคตของวิชาชีพของตนได้
                <br />
                &nbsp;&emsp;&emsp;&emsp;2. ลูกจ้างต้องใช้ความระมัดระวังอย่างยิ่ง
                ในการเผยแพร่ความคิดเห็นที่อาจกระตุ้นหรือนำไปสู่การโต้แย้งที่รุนแรง
                เช่น เรื่องเกี่ยวกับการเมืองหรือศาสนา
                <br />
                &nbsp;&emsp;&emsp;&emsp;3. ลูกจ้างต้องพึงระลึกว่า
                พระราชบัญญัติว่าด้วยการกระทำผิดเกี่ยวกับคอมพิวเตอร์ พ.ศ.๒๕๕๐ และ
                ข้อบังคับว่าด้วยจรรยาบรรณของพนักงานบริษัท {company.name_th}{" "}
                และบริษัทในเครือ ข้อบังคับว่าด้วยระเบียบการปฏิบัติงาน
                มีผลผูกพันต่อการเผยแพร่ข้อมูลและแสดงความคิดเห็นบน Social Network
                ด้วย
                ว่าด้วยจรรยาบรรณของพนักงานทุกท่านในการเปิดเผยข้อมูลความความลับทางการค้า
                และข้อมูลความลับของบริษัทฯ ในประกาศ เลขที่อ้างอิง MEMO
                HRC-5807006 เรื่อง การห้ามเปิดเผยข้อมูล ความลับทางการค้า
                และข้อมูลความลับ ที่ประกาศไว้เมื่อวันที่ 21 กรกฎาคม 2558
                และประกาศฉบับแก้ไขเมื่อวันที่ 15 กุมภาพันธ์ 2561
                การละเมิดข้อบังคับ
                และข้อกำหนดตามประกาศกำหนดดังกล่าวถือว่าเป็นการประพฤติผิดจรรยาบรรณอย่างร้ายแรงและเป็นการทำให้บริษัทฯ
                ได้รับความเสียหาย ซึ่งพนักงานอาจได้รับการลงโทษในขั้นร้ายแรง
                เช่นไล่ออก พักงาน เป็นต้น
              </div>
            </div>
            <div id="var" className="var">
            {company2.head && (
                <img
                  src={company2.head}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "100px",
                    right: "10px",
                    top: "20px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              {company2.foot && (
                <img
                  src={company2.foot}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "70px",
                    right: "10px",
                    top: "1060px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              <div
                id="date_day"
                class="date day docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "228.5px",
                  right: "286px",
                  fontSize: "18.2px",
                  width: "30px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.date_day}
              </div>

              <div
                id="date_month"
                class="date month docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "228.5px",
                  right: "150px",
                  fontSize: "18.2px",
                  width: "106px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.date_month}
              </div>
              <div
                id="date_year"
                class="date year docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "228.5px",
                  right: "79px",
                  fontSize: "18.2px",
                  width: "46px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.date_year}
              </div>

              <div
                id="personal_info_name"
                class="personal_info name docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "280px",
                  right: "77px",
                  fontSize: "18.2px",
                  width: "463px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_name}
              </div>
              <div
                id="personal_info_age"
                class="personal_info age docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "306px",
                  right: "637px",
                  fontSize: "18.2px",
                  width: "69px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_age || 25}
              </div>

              <div
                id="personal_info_house_No"
                class="personal_info house_No docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "306px",
                  right: "462px",
                  fontSize: "18.2px",
                  width: "91px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_house_No}
              </div>

              <div
                id="personal_info_village_No"
                class="personal_info village_No docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "306px",
                  right: "369px",
                  fontSize: "18.2px",
                  width: "64px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_village_No}
              </div>
              <div
                id="personal_info_lane"
                class="personal_info lane docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "306px",
                  right: "77px",
                  fontSize: "18.2px",
                  width: "232px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_lane}
              </div>

              <div
                id="personal_info_road"
                class="personal_info road docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "333px",
                  right: "423px",
                  fontSize: "18.2px",
                  width: "272px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_road}
              </div>

              <div
                id="personal_info_sub_district"
                class="personal_info sub_district docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "333px",
                  right: "77px",
                  fontSize: "18.2px",
                  width: "264px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_sub_district}
              </div>

              <div
                id="personal_info_district"
                class="personal_info district docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "362.5px",
                  right: "489px",
                  fontSize: "18.2px",
                  width: "178px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_district}
              </div>

              <div
                id="personal_info_province"
                class="personal_info province docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "362.5px",
                  right: "284px",
                  fontSize: "18.2px",
                  width: "155px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_province}
              </div>
            </div>
          </div>
          <div
            id="page2"
            class="page-break"
            style={{
              position: "absolute",
              top: "1150px",
              right: "0%",
              fontFamily: "THSarabun",
            }}
          >
            <div>
              <img
                id="background"
                src={bg}
                alt="bg"
                style={{
                  width: "800px",
                  height: "auto",
                  position: "relative",
                  // top: "1150px",
                  // right: "0%",
                  zIndex: -5,
                  boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                }}
              />
              <div
                id="content"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "0px",
                  right: "0px",
                }}
              >
                  {company2.head && (
                <img
                  src={company2.head}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "100px",
                    right: "10px",
                    top: "20px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              {company2.foot && (
                <img
                  src={company2.foot}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "70px",
                    right: "10px",
                    top: "1060px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
                <div
                  className="docs-font"
                  id="paragraph1"
                  style={{
                    zIndex: 2,
                    position: "relative",
                    top: "135px",
                    right: "74px",
                    fontSize: "18.2px",
                    // fontFamily: "angsaLight",
                    width: "655px",
                    letterSpacing: 0.14,
                    textAlign: "justify",
                    lineHeight: "27px",
                  }}
                >
                  &nbsp;&emsp;&emsp;&emsp;4.
                  ลูกจ้างต้องไม่ละเมิดทรัพย์สินทางปัญญาของผู้อื่น
                  หากต้องการกล่าวอ้างถึงแหล่งข้อมูลที่สนับสนุนข้อความของตน
                  ควรอ้างอิงถึงแหล่งข้อมูลนั้นอย่างชัดเจน (เช่น
                  ให้เครดิตเจ้าของเรื่องว่านำผลงานของบุคคลใดมาอ้างอิง)
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;5. ลูกจ้างพึงตระหนักว่า การใช้ Social
                  Network นั้น การแบ่งแยกระหว่างเรื่องส่วนตัว
                  และเรื่องหน้าที่การงาน เป็นสิ่งที่ทำได้ยาก หากประสงค์จะใช้
                  Social Network
                  เพื่อเผยแพร่ข้อมูลเกี่ยวกับเรื่องหน้าที่การงานหรือข้อมูลเกี่ยวกับหน่วยงาน
                  ควรแยกบัญชีผู้ใช้ (Account) ระหว่างการใช้เพื่อเรื่องส่วนตัว
                  และเรื่องหน้าที่การงานออกจากกัน ยกตัวอย่างเช่น การใช้ Facebook
                  ของผู้ที่ทำหน้าที่ประชาสัมพันธ์ของส่วนงาน ควรมีการแยก Facebook
                  Profile ที่ใช้สำหรับติดต่อกับเครือข่ายของตนในเรื่องส่วนตัว
                  เรื่องครอบครัว ออกจาก Facebook Profile
                  ที่ใช้ประชาสัมพันธ์ส่วนงาน หรืออาจตั้งเป็น Facebook Page
                  ประจำส่วนงานขึ้นแทนที่จะใช้ Profile ส่วนตัว
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;6. หากลูกจ้างประสงค์สร้าง Page หรือ
                  Account
                  ที่เป็นช่องทางในการเผยแพร่ข้อมูลอย่างเป็นทางการของส่วนงานหรือบริษัท
                  จะต้องแจ้งให้หัวหน้าส่วนงานและผู้บริหารระดับ C2
                  รับทราบอนุมัติก่อนดำเนินการ แล้วแต่กรณี
                  และต้องแจ้งรายชื่อของผู้ดูแล Page (Admin) หรือเจ้าของ Account
                  นั้นให้หัวหน้าส่วนงานรับทราบด้วย
                  และผู้ดูแลมีหน้าที่ต้องมอบสิทธิ์ในการดูแล Page หรือ Account
                  นั้นคืนแก่ส่วนงานหรือบริษัท เมื่อพ้นจากหน้าที่ที่ต้องดูแล
                  หรือพ้นสภาพจากการเป็นพนักงาน
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;7. การเผยแพร่ข้อมูล
                  หรือแสดงความเห็นที่อาจทำให้เข้าใจว่าเป็นความเห็นจากบริษัท
                  ส่วนงาน หรือหน่วยงาน ต้องมีการแสดงข้อความจำกัดความรับผิดชอบ
                  (Disclaimer) ว่า เป็นความเห็นส่วนตัว มิใช่ความเห็นของบริษัท
                  ส่วนงาน หรือหน่วยงานที่ตนสังกัด เว้นแต่จะเป็นความเห็นของบริษัท
                  ส่วนงานหรือหน่วยงานอย่างแท้จริง
                  หรือความเห็นนั้นได้รับอนุญาตจากผู้มีอำนาจที่เกี่ยวข้องแล้วแต่กรณี
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;8. ผู้บริหารในระดับใดๆ ก็ตาม
                  พึงระมัดระวังในการเผยแพร่ข้อมูล
                  หรือการแสดงความเห็นเนื่องจากอาจจะทำให้เห็นได้ว่าเป็นความเห็นของหน่วยงานของตนได้ง่าย
                  และอาจมีผลกระทบต่อความเข้าใจของผู้ใต้บังคับบัญชาได้
                  ทั้งนี้ให้มีการแสดงข้อความจำกัดความรับผิดชอบอย่างชัดเจนเช่นเดียวกับข้อ
                  7
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;9.
                  ห้ามลูกจ้างเผยแพร่ข้อมูลที่เป็นทรัพย์สินทางปัญญาของบริษัท&nbsp;&nbsp;
                  หรือข้อมูลที่ใช้ภายในบริษัท &nbsp;&nbsp;ก่อนได้รับอนุญาตอย่าง
                  ชัดเจนจากหัวหน้างานหรือกรรมการบริษัท
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;10.
                  ห้ามลูกจ้างที่ปฏิบัติงานหน้าร้าน&nbsp;
                  หรือในบริษัทสำนักงานใหญ่ที่อาจใช้ตราสัญลักษณ์&nbsp; (Logo)
                  &nbsp;เช่น&nbsp; ใส่เสื้อที่มีแบรนด์ บานาน่า แอปเปิ้ล
                  สตูดิโอเซเว่น และอื่น ๆ
                  ถ่ายรูปส่วนตัวที่ทำให้เกิดความเสื่อมเสียแก่บริษัท
                  หรือใช้ตราสัญลักษณ์นั้นบนนามบัตรโดยไม่ได้รับอนุญาต
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;ทั้งนี้หากประสงค์ที่จะใช้ตราสัญลักษณ์นั้นเพื่อโฆษณา ประชาสัมพันธ์ สินค้า ผลิตภัณฑ์ หรือการบริการใดๆ จะต้อง
                  ได้รับอนุญาตจากหัวหน้างานผู้มีอำนาจหรือกรรมการก่อนดำเนินการ <br/>
                  &nbsp;&emsp;&emsp;&emsp;หากลูกจ้างฝ่าฝืนเงื่อนไขตรงข้อนี้เป็นเหตุให้เกิดความเสียหายแก่บริษัท ลูกจ้างรับทราบว่าบริษัทมีสิทธิพิจารณาลงโทษ
                  ด้วยการไล่ออก เลิกจ้าง  และจะต้องถูกฟ้องร้องดำเนินคดีตามกฎหมายโดยถึงที่สุด<br/>

                  &nbsp;&emsp;&emsp;&emsp;11. ลูกจ้างปฏิบัติงานวิชาชีพ&nbsp;
                  หรือเป็นผู้ให้บริการอื่นใด&nbsp;
                  พึงตระหนักถึงความรับผิดชอบในการเผยแพร่ข้อมูลเกี่ยวกับผู้รับบริการ
                  เนื่องจากผลของการเผยแพร่ข้อมูล อาจมีผลกระทบต่อผู้รับบริการ
                  หน่วยงาน และวิชาชีพของตนได้ โดยที่
                  <br />
                  &nbsp;&nbsp;&emsp;&emsp;&emsp;&nbsp;&emsp;&emsp;&emsp;11.1
                  ระมัดระวังอย่างยิ่งในการใช้&nbsp;&nbsp;&nbsp; Social&nbsp;
                  Network&nbsp;&nbsp;
                  ในการปฏิสัมพันธ์กับผู้รับบริการโดยเฉพาะไม่ควรใช้ Account
                  ที่ใช้สำหรับเรื่องส่วนตัวเพื่อการนี้
                  เนื่องจากไม่มีวิธีที่ได้ผลสมบูรณ์
                  ในการปกปิดความลับของผู้รับบริการ บน Social Network
                  <br />
                  &nbsp;&nbsp;&emsp;&emsp;&emsp;&nbsp;&emsp;&emsp;&emsp; 11.2
                  ปฏิบัติตามจริยธรรมของวิชาชีพอย่างเคร่งครัด
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;&nbsp;&emsp;&emsp;&emsp;11.3
                  เคารพและระมัดระวังอย่างยิ่ง
                  &nbsp;ไม่ให้มีการละเมิดความเป็นส่วนตัว &nbsp; &nbsp;(Privacy)
                  &nbsp; &nbsp;และความลับ (Confidentiality) ของผู้รับบริการ
                </div>
              </div>
            </div>
          </div>
          <div
            id="page3"
            class="page-break"
            style={{
              position: "absolute",
              top: "2300px",
              right: "0%",
              fontFamily: "THSarabun",
            }}
          >
            <div>
              <img
                id="background"
                src={bg}
                alt="bg"
                style={{
                  width: "800px",
                  height: "auto",
                  position: "relative",
                  // top: "1150px",
                  // right: "0%",
                  zIndex: -5,
                  boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                }}
              />
              <div
                id="content"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "0px",
                  right: "0px",
                }}
              >
                <div
                  className="docs-font"
                  id="paragraph1"
                  style={{
                    zIndex: 2,
                    position: "relative",
                    top: "133px",
                    right: "74px",
                    fontSize: "18.2px",
                    // fontFamily: "angsaLight",
                    width: "655px",
                    letterSpacing: 0.14,
                    textAlign: "justify",
                    lineHeight: "25px",
                  }}
                >
                  &nbsp;&nbsp;&emsp;&emsp;&emsp;&nbsp;&emsp;&emsp;&emsp;11.4
                  หากลูกจ้างประสงค์ที่จะเผยแพร่ข้อมูลเพื่อการศึกษา เช่น รูปภาพ
                  หรือสื่ออื่นๆ ที่มาจากผู้รับบริการ ต้อง
                  ขออนุญาตจากผู้รับบริการนั้นก่อนเสมอ
                  &nbsp;&nbsp;และต้องลบข้อมูล&nbsp;&nbsp;&nbsp;
                  ที่อาจจะทำให้มีการทราบถึงตัวตนของผู้รับบริการนั้นให้หมด
                  เว้นแต่จะได้รับอนุญาตเป็นลายลักษณ์อักษรจากผู้รับบริการ
                  ทั้งนี้ให้รวมถึงการเผยแพร่ข้อมูลในกลุ่มปิดเฉพาะด้วย
                  <br />
                  &nbsp;&nbsp;&emsp;&emsp;&emsp;&nbsp;&emsp;&emsp;&emsp;11.5
                  หากพบเพื่อนร่วมหน่วยงาน ส่วนงาน หรือ
                  บริษัทฯ&nbsp;&nbsp;&nbsp;ใช้&nbsp;&nbsp; Social Network
                  &nbsp;&nbsp;เกี่ยวกับผู้รับบริการอย่าง ไม่เหมาะสม
                  ขอให้ตักเตือนโดยตรง หากไม่ได้รับการตอบสนองที่ดี
                  ให้แจ้งต่อผู้บังคับบัญชาของผู้นั้น
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;12.
                  ลูกจ้างควรแจ้งให้ผู้รับผิดชอบของหน่วยงาน ส่วนงาน
                  หรือบริษัททราบ หากพบว่ามีข้อความบน Social Network
                  ที่อาจทำให้เกิดความเสื่อมเสียชื่อเสียงของหน่วยงาน
                  ส่วนงานหรือบริษัทได้ สำหรับหน่วยงานหรือส่วนงาน
                  ควรมอบหมายให้มีผู้เฝ้าระวังและตรวจตราข่าวสารในทุกช่องทางที่อาจส่งผลกระทบต่อชื่อเสียงของหน่วยงานหรือส่วนงานนั้นได้
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;13. ลูกจ้างควรศึกษาการใช้
                  “การตั้งค่าความเป็นส่วนตัว” หรือ “Privacy Settings”
                  ให้เข้าใจเป็นอย่างดี
                  และปรับแต่งการตั้งค่าความเป็นส่วนตัวให้เหมาะสมกับบริบท
                  การถูกละเมิดความเป็นส่วนตัวโดยไม่เหมาะสม
                  นอกเหนือจากส่งผลกระทบต่อตนเองแล้ว อาจส่งผลต่อหน่วยงาน
                  ส่วนงานและบริษัทได้ด้วย
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;14.
                  ในกรณีที่หน่วยงานหรือส่วนงานมีนโยบายที่นอกเหนือจากนี้
                  ให้ปฏิบัติตามที่กำหนด
                  เพื่อป้องกันมิให้เกิดความเสียหายกับบริษัทในทุกด้าน
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;15.ห้ามมิให้ลูกจ้างเผยแพร่รูปหรือข้อมูลใดๆขององค์กร
                  บน Social Network ทุกชนิดที่ก่อให้เกิดความเสียหายแก่บริษัท
                  ส่งผลให้เกิดภาพลักษณ์ที่ไม่ดีหรือในทางลบต่อบริษัท
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;16.
                  ห้ามลูกจ้างเผยแพร่ข่าวสารและโปรโมชั่นของทางบริษัทบน Social
                  Network ก่อนได้รับอนุญาตจากส่วนงาน หน่วยงานที่รับผิดชอบ หรือ
                  บริษัท
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;ข้าพเจ้าได้อ่านและรับทราบข้อความในหนังสือนี้โดยตลอดและเข้าใจอย่างละเอียดถี่ถ้วนแล้ว
                  จึงได้ลงลายมือชื่อไว้เป็นสำคัญต่อหน้าพยาน
                  <br />
                  <br />
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;ลงชื่อ....................................................................................ลูกจ้าง
                  <br />
                  &nbsp;&nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(...................................................................................)
                  <br />
                  <br />
                  <br />
                  <p />
                  ลงชื่อ...................................................................................พยาน&nbsp;&nbsp;&emsp;
                  ลงชื่อ...................................................................................พยาน
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(..................................................................................)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&emsp;&emsp;&emsp;
                  (..................................................................................)
                </div>
              </div>
            </div>

            <div id="var" class="var">
            {company2.head && (
                <img
                  src={company2.head}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "100px",
                    right: "10px",
                    top: "20px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              {company2.foot && (
                <img
                  src={company2.foot}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "70px",
                    right: "10px",
                    top: "1060px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              <div
                id="personal_info_name2"
                class="personal_info name2 docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "682px",
                  right: "276px",
                  fontSize: "18.2px",
                  width: "251px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_name}
              </div>
            </div>
          </div>
        </PDFExport>
      </div>
    </>
  );
};

HRM_054.propTypes = {
  data: PropTypes.object.isRequired,
  pdfExportComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.object }),
  ]),
};

export default HRM_054;
